<form>
  <mat-form-field class="w-100">
    <mat-label>{{ label || "Selected Items" }}</mat-label>
    <mat-chip-grid #chipGrid aria-label="Item selection">
      @for (item of items(); track item.id) {
        <mat-chip-row (removed)="remove(item)">
          {{ item.name }}
          <button matChipRemove [attr.aria-label]="'remove ' + item.name">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>

    <input
      name="currentItem"
      placeholder="Search items..."
      #itemInput
      [(ngModel)]="currentItem"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="auto"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [disabled]="disabled"
      (matChipInputTokenEnd)="add($event)"
      (focus)="openOnFocus()"
      (blur)="onTouched()"
      />

    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="selected($event); itemInput.value = ''"
      appMatAutocompleteInfiniteScroll
      (infiniteScroll)="this.pagination.loadNextPage()"
      >
      @for (item of filteredItems(); track item.id) {
        <mat-option [value]="item">{{ item.name }}</mat-option>
      }

      @if (pagination.loadingMore) {
        <mat-option disabled>
          <mat-spinner diameter="20"></mat-spinner>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>
